import React from 'react';
import './Pages.css';

const Sales = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Sales</h1>
        <p>Sales data and analytics</p>
      </div>
      <div className="page-content">
        <p>Sales content goes here...</p>
      </div>
    </div>
  );
};

export default Sales;